import React from "react";

const DANGEROUS_TAGS = ['script', 'foreignobject', 'iframe', 'object', 'embed', 'link', 'meta', 'base', 'applet', 'form'];
const DANGEROUS_ATTRS = ['href', 'xlink:href', 'src', 'action', 'formaction', 'data'];

export const validateSVGContent = (svgString) => {
	if (!svgString || !svgString.trim()) {
		return 'SVG content is required';
	}

	const trimmed = svgString.trim();

	if (!/<svg[\s>]/i.test(trimmed)) {
		return 'Content must be a valid SVG — must contain an <svg> element';
	}

	let doc;
	try {
		const parser = new DOMParser();
		doc = parser.parseFromString(trimmed, 'image/svg+xml');
		if (doc.querySelector('parsererror')) {
			return 'Invalid SVG: the markup could not be parsed';
		}
	} catch (e) {
		return 'Invalid SVG: parsing failed';
	}

	const allElements = doc.querySelectorAll('*');

	for (const el of allElements) {
		const tag = el.tagName.toLowerCase().replace(/^svg:/, '');

		if (DANGEROUS_TAGS.includes(tag)) {
			return `SVG contains disallowed element: <${tag}>`;
		}

		for (const attr of el.attributes) {
			const name = attr.name.toLowerCase();
			const value = attr.value.replace(/\s/g, '').toLowerCase();

			// Block all event handlers
			if (name.startsWith('on')) {
				return `SVG contains disallowed event handler: ${attr.name}`;
			}

			// Block javascript: and vbscript: in URL attributes
			if (DANGEROUS_ATTRS.includes(name)) {
				if (/^(javascript|vbscript):/.test(value)) {
					return `SVG contains disallowed script URL in attribute: ${attr.name}`;
				}
				// Block non-image data: URIs
				if (/^data:/.test(value) && !/^data:image\//.test(value)) {
					return `SVG contains disallowed data URI in attribute: ${attr.name}`;
				}
				// Block external references in <use>
				if (tag === 'use' && /^(https?:)?\/\//.test(value)) {
					return 'SVG contains disallowed external reference in <use>';
				}
			}

			// Block CSS expressions and script bindings in style
			if (name === 'style') {
				const style = attr.value.toLowerCase();
				if (/expression\s*\(|javascript\s*:|vbscript\s*:|-moz-binding/.test(style)) {
					return 'SVG contains dangerous CSS in style attribute';
				}
			}
		}
	}

	return null;
};

const isValidLink = function (link) {
	link = link.trim();

	const urlRegex =
		/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

	return urlRegex.test(link);
};

export const validateNavData = function (data, isEdit = false) {
	const errors = {};

	if (!data.name || !data.name.trim()) {
		errors.name = "Tab Name is required";
	}

	if (!data.tooltip || !data.tooltip.trim()) {
		errors.tooltip = "Tooltip is required";
	}

	if (!data.position) {
		errors.position = "Placement is required";
	}

	if (!data.type && data.coreId !== "LIA") {
		errors.type = "Link type is required";
	}

	if (!isEdit && data.coreId !== "LIA") {
		if (!data.link || !data.link.trim()) {
			errors.link = "Link is required";
		} else if (!isValidLink(data.link)) {
			errors.link = "Invalid link format. Example: https://www.example.com/page";
		}
	}

	if (!data.iconType) {
		errors.iconType = "Icon type is required";
	}

	if (data.iconType === "SVG" && !data.icon) {
		errors.icon = "SVG icon is required";
	}

	if (data.iconType === "CUSTOM_SVG") {
		const svgError = validateSVGContent(data.icon);
		if (svgError) {
			errors.icon = svgError;
		}
	}

	if (data.iconType === "IMAGE" && !data.imageId && !data.icon) {
		errors.image = "Image is required";
	}

	return errors;
};
